import {RouterProvider} from 'react-router-dom';
import router from './Routes';
import {AlertProvider} from './context/Alert';

const Router = () => {
  return (
    <AlertProvider>
      <RouterProvider router={router} />;
    </AlertProvider>
  );
};

export default Router;
